// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ScrollLockService {
    private renderer: Renderer2;
    private scrollLocked = false;

    constructor(private rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    lockScroll(): void {
        if (!this.scrollLocked) {
            this.renderer.setStyle(document.body, 'overflow', 'hidden');
            this.scrollLocked = true;
        }
    }

    unlockScroll(): void {
        if (this.scrollLocked) {
            this.renderer.removeStyle(document.body, 'overflow');
            this.scrollLocked = false;
        }
    }
}
